import axios from 'axios'

export default {
  namespaced: true,
  state: {
    workTypeCategoryGrid: [],
    workTypeCategoryGridAll: [],
    workTypeCategoryData: null,
    pageData: null,
  },
  mutations: {
    setWorkTypeCategoryGrid(state, payload) {
      state.workTypeCategoryGrid = payload
    },
    setWorkTypeCategoryGridAll(state, payload) {
      state.workTypeCategoryGridAll = payload
    },
    setWorkTypeCategoryData(state, payload) {
      state.workTypeCategoryData = payload
    },
    setPageData(state, payload) {
      state.pageData = payload
    },
  },
  getters: {
    workTypeCategoryGrid: (state) => {
      return state.workTypeCategoryGrid
    },
    workTypeCategoryGridAll: (state) => {
      return state.workTypeCategoryGridAll
    },
    workTypeCategoryData: (state) => {
      return state.workTypeCategoryData
    },
    pageData: (state) => {
      return state.pageData
    },
  },
  actions: {
    onWorkTypeCategoryGrid({ commit, rootState }, { limit, page, sort, search }) {
      commit('setLoadingAnimation', true, { root: true })
      let url =
        rootState.apiDomain + '/api/admin/work/type/category/grid?limit=' + limit + '&page=' + page
      if (sort) {
        url = url + '&order[]=' + sort.param + ':' + sort.value
      } else {
        url = url + '&order[]=name:asc'
      }
      if (search) url = url + '&search=' + search
      return new Promise((resolve, reject) => {
        axios({
          url,
          limit: limit,
          page: page,
          method: 'GET',
        })
          .then((resp) => {
            commit('setWorkTypeCategoryGrid', resp.data.data)
            commit('setPageData', resp.data)
            commit('setLoadingAnimation', false, { root: true })
            resolve(resp)
          })
          .catch((err) => {
            commit('setLoadingAnimation', false, { root: true })
            reject(err)
          })
      })
    },
    onWorkTypeCategoryGridAll({ commit, rootState }) {
      return new Promise((resolve, reject) => {
        axios({
          url:
            rootState.apiDomain +
            '/api/admin/work/type/category/grid?limit=0' +
            '&order[]=name:asc',
          method: 'GET',
        })
          .then((resp) => {
            commit('setWorkTypeCategoryGridAll', resp.data.data)
            resolve(resp)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },
    onWorkTypeCategoryData({ commit, rootState }, id) {
      return new Promise((resolve, reject) => {
        axios({
          url: rootState.apiDomain + '/api/admin/work/type/category/' + id,
          id: id,
          method: 'GET',
        })
          .then((resp) => {
            commit('setWorkTypeCategoryData', resp.data.data)
            resolve(resp)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },
    onWorkTypeCategoryCreate({ rootState }, data) {
      return new Promise((resolve, reject) => {
        axios({
          url: rootState.apiDomain + '/api/admin/work/type/category',
          data: data,
          method: 'POST',
        })
          .then((resp) => {
            resolve(resp)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },
    onWorkTypeCategoryUpdate({ rootState }, data) {
      return new Promise((resolve, reject) => {
        axios({
          url: rootState.apiDomain + '/api/admin/work/type/category',
          data: data,
          method: 'PUT',
        })
          .then((resp) => {
            resolve(resp)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },
    onWorkTypeCategoryDelete({ rootState }, { id, checkbox }) {
      return new Promise((resolve, reject) => {
        axios({
          url:
            rootState.apiDomain +
            '/api/admin/work/type/category/' +
            id +
            '?with_relations=' +
            checkbox,
          checkbox: checkbox,
          id: id,
          method: 'DELETE',
        })
          .then((resp) => {
            resolve(resp)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },
  },
}
